module.exports = __webpack_public_path__ + "static/media/NeuropsychologicalAssessment - Icon.2c502a3d.svg";